import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getIsaCreditRiskTypes, saveBatchIsaCreditRiskTypes } from '../../api/isaCreditRiskTypes';
import type { IsaCreditRiskType } from '../../types/IsaCreditRiskType';
import { t } from '../../i18n/t';

const columnDefs: ColDef<IsaCreditRiskType>[] = [
  {
    field: 'creditRiskTypeId',
    headerName: t('isaCreditRiskTypes.columns.creditRiskTypeId'),
    width: 140,
    cellDataType: 'number',
    editable: (params: EditableCallbackParams<IsaCreditRiskType>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  {
    field: 'creditRiskTypeName',
    headerName: t('isaCreditRiskTypes.columns.creditRiskTypeName'),
    flex: 1,
    editable: true,
  },
];

const newRowDefaults = (): Partial<IsaCreditRiskType> => ({
  creditRiskTypeId: 0,
  creditRiskTypeName: '',
});

export function IsaCreditRiskTypesPage() {
  return (
    <LopCrudPage<IsaCreditRiskType>
      resourceCode="isaCreditRiskTypes"
      titleKey="isaCreditRiskTypes.pageTitle"
      idField="creditRiskTypeId"
      getRows={getIsaCreditRiskTypes}
      saveBatch={(added, modified, deletedIds) =>
        saveBatchIsaCreditRiskTypes(added, modified, deletedIds as number[])
      }
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
